// ECharts triggers ResizeObserver during chart layout; defer callbacks to avoid the
// benign browser warning that CRA's dev overlay treats as a fatal runtime error.
const resizeObserverErr =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

function isResizeObserverNoise(value) {
  return resizeObserverErr.test(String(value || ''));
}

if (typeof window !== 'undefined' && window.ResizeObserver && !window.__resizeObserverPatched) {
  const NativeResizeObserver =
    window.__NativeResizeObserver || window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frameId = null;
      super((entries, observer) => {
        if (frameId !== null) {
          cancelAnimationFrame(frameId);
        }
        frameId = requestAnimationFrame(() => {
          frameId = null;
          callback(entries, observer);
        });
      });
    }
  };
  window.__resizeObserverPatched = true;
}

if (typeof window !== 'undefined') {
  function swallowRoError(event) {
    if (isResizeObserverNoise(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  window.addEventListener('error', swallowRoError, false);
  window.addEventListener('error', swallowRoError, true);

  const prevOnError = window.onerror;
  window.onerror = function onError(message, source, lineno, colno, error) {
    if (isResizeObserverNoise(message) || isResizeObserverNoise(error?.message)) {
      return true;
    }
    if (typeof prevOnError === 'function') {
      return prevOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  const prevConsoleError = console.error;
  console.error = (...args) => {
    if (args.some((arg) => isResizeObserverNoise(arg) || isResizeObserverNoise(arg?.message))) {
      return;
    }
    prevConsoleError.apply(console, args);
  };
}
